module.exports = __webpack_public_path__ + "r-v3/img/ml_22_00.e6b1438d.jpg";